module.exports = __webpack_public_path__ + "img/stack-overflow-dreaded-language.e14da5f2.png";